import { useMemo } from 'react'

import { Offer } from '@wwt/entities/search-response'

import { formatDate } from '../utils/formatDate.ts'

export const useOfferCardTitle = (offer: Offer) => {
	return useMemo(
		() => ({
			roomName: offer.roomDynamic.name,
			dateInterval: `${formatDate(offer.roomDynamic.checkIn)} - ${formatDate(
				offer.roomDynamic.checkOut
			)}`
		}),
		[offer]
	)
}
